/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AllAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ButtonBreadcrumbUnder from 'DesignSystem/ButtonBreadcrumbUnder/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AllAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/AllAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={14}
 height={14}
 marginLeft={16}
 marginRight={16}
 stroke="rgba(0,0,0,0.3)"
/>
<ButtonBreadcrumbUnder
  viewPath={`${viewPath}/ButtonBreadcrumbUnder`}
 onClick={() => setFlowTo("/App/Account/Content/Comms/ActiveThread/Content/MessageTools/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/AllFilesActions")}
 isSelected={flow.has("/App/Account/Content/Comms/ActiveThread/Content/MessageTools/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/AllFilesActions")}
/>
{children}
</React.Fragment>)
}